<template>
  <q-select
    v-bind="vAttrs"
    :loading="options.length === 0"
    :options="options"
    v-on="$listeners"
  >
    <template
      v-for="(slot, k) in $slots"
      #[k]
    >
      <slot :name="k" />
    </template>
    <template
      v-for="(slot, k) in $scopedSlots"
      #[k]="props"
    >
      <slot
        :name="k"
        v-bind="props"
      />
    </template>
  </q-select>
</template>

<script>
import { mapState } from 'vuex'
import validateProxyMixin from '@/mixins/validateProxyMixin'

export default {
  name: 'SelectExpirationType',
  mixins: [validateProxyMixin],
  inheritAttrs: false,
  computed: {
    ...mapState({
      CONSTS: 'CONSTS'
    }),
    options () {
      return _.sortBy(_.get(this.CONSTS, 'agentExpirationTypes', []), 'name')
    },
    vAttrs () {
      return {
        label: `Type d'expiration`,
        'option-label': 'name',
        'option-value': 'id',
        ...this.$attrs
      }
    }
  }
}
</script>

<style scoped>

</style>
